<template>
  <div id="ExamStaff">
    <van-dropdown-menu>
      <van-dropdown-item v-model="organname" :options="organ_list" />
      <van-dropdown-item v-model="tabIndex" :options="status_list" />
    </van-dropdown-menu>

    <div>
      <van-panel
        v-for="(e,i) in drawdata"
        :key="i"
        :title="e.RealName"
        :status="e.StatusText"
        icon="manager"
        class="text-left"
      >
        <div class="m-2 pl-2">
          <van-cell
            icon="friends-o"
            v-if="e.Tel"
            title="性别:"
            :value="(e.UserSex == 1) ? '男' : (e.UserSex == 2) ? '女' : ''"
          />
          <van-cell icon="phone-circle-o" v-if="e.Tel" title="电话:" :value="e.Tel" />
          <van-cell icon="phone-o" v-if="e.Tel" title="手机:" :value="e.Phone" />
          <van-cell icon="home-o" v-if="e.Tel" title="机构:" :value="e.OrganName" />
        </div>
        <div slot="footer" class="text-right">
          <van-button size="small" @click="setExamStaffStatus(e,1)" type="primary">同意</van-button>
          <van-button size="small" @click="setExamStaffStatus(e,3)">驳回</van-button>
          <van-button size="small" @click="setExamStaffStatus(e,2)" type="danger">拒绝</van-button>
        </div>
      </van-panel>
    </div>

    <van-divider>
      查询到
      <b>{{ drawdata.length }}</b> 条记录
    </van-divider>
  </div>
</template>
<script>
export default {
  name: "ExamStaff",
  data() {
    return {
      staffdata: [],
      drawdata: [],
      organ_array: [],
      organ_list: [],
      organname: "所有机构",
      status_list: [
        { text: "待审核", value: 0 },
        { text: "同意", value: 1 },
        { text: "拒绝", value: 2 },
        { text: "驳回", value: 3 },
        { text: "全部", value: 4 }
      ],
      tabIndex: 4
    };
  },
  watch: {
    organname: function() {
      this.drawExamStaffList();
    },
    tabIndex: function() {
      this.drawExamStaffList();
    }
  },
  methods: {
    /* 数据获取 */
    getExamStaffData() {
      let _WorkID = this.$route.params.id;
      if (!_WorkID) {
        this.$router.push({ name: "ExamManage" }); //如果考试工作id为空的话返回上级页面
      }
      this.apiReviewRegOrganUser(
        {
          WorkID: _WorkID,
          OrganID: this.getAuth().OrganID,
          RoleID: 1,
          Status: 1,
          UserType: "0",
          PageIndex: 1,
          PageSize: 9999
        },
        this,
        res => {
          console.log("res:", res);
          this.staffdata = res;
          this.organ_list.push({
            text: "所有机构",
            value: "所有机构"
          });
          res.forEach(element => {
            if (this.organ_array.indexOf(element.OrganName) == -1) {
              this.organ_array.push(element.OrganName);
              this.organ_list.push({
                text: element.OrganName,
                value: element.OrganName
              });
            }
          });
          this.drawExamStaffList();
        }
      );
    },
    drawExamStaffList() {
      this.drawdata = []; //将绘制数据置空
      var tempArray = []; //定义临时数组用于存放机构条件筛选人员名单
      //判断机构条件是否选择,如果选择了机构则循环工作人员的机构属性是否相同
      if (this.organname == "所有机构") {
        //如果没有选择机构条件则将工作人员全部赋给临时数组
        tempArray = this.staffdata;
      } else {
        this.staffdata.forEach(e => {
          if (e.OrganName == this.organname) tempArray.push(e);
        });
      }
      //判断审核条件,如果为4(全部)的话将临时数组赋给绘制数据
      if (this.tabIndex == 4) {
        this.drawdata = tempArray;
      } else {
        //如果选择了审核条件,则循环临时数组,将审核条件相等的记录赋给绘制数据
        tempArray.forEach(e => {
          if (e.Status == this.tabIndex) {
            this.drawdata.push(e);
          }
        });
      }
      tempArray = []; //将临时数组置空
    },
    setExamStaffStatus(e, status) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定执行操作？"
        })
        .then(() => {
          // on confirm
          var memo = "";
          //提交设置
          this.apiOrganWorkerPost(
            {
              WorkID: this.$route.params.id,
              OpenID: e.OpenID,
              Status: status,
              Memo: memo
            },
            this,
            e => {
              if (e.result == 1) {
                this.getExamStaffData();
              } else {
                this.$mui.toast(e.msg);
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  created() {
    this.getExamStaffData();
  }
};
</script>
<style scoped></style>